import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import TextField from 'components/field'

const getLabelBottomMargin = props => props.theme.field.label.bottomMargin
const getFieldMargin = props => props.theme.field.margin || '-20px -20px 20px -20px'
const getMobileFieldMargin = props =>
  props.margin || props.theme.field.mobileMargin || props.theme.field.margin || '-20px -20px 20px -20px'

const LoginFormField = styled(TextField)`
  padding: 20px 20px 0 20px;
  margin: ${getMobileFieldMargin};

  & > label {
    margin-bottom: ${getLabelBottomMargin};
  }

  &:nth-child(4) {
    margin-bottom: 0;
  }

  ${breakpoint('portrait')`
    margin: ${getFieldMargin};
  `};
`

export default LoginFormField
